import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State } from '../states/avc-credit-line-state';

export const avcCreditLine = createFeatureSelector<State>('avc_credit_line');

export const selectCreditLineStatus = createSelector(avcCreditLine, (state: State) => state?.creditLineStatus);

export const selectCreditLineStatusLoading = createSelector(avcCreditLine, (state: State) => state?.creditLineStatusLoading);

export const selectCreditLineStatusError = createSelector(avcCreditLine, (state: State) => state?.isError);

